// eslint-disable-next-line import/no-extraneous-dependencies
import * as React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20.3}
    height={20.3}
    className={className}
  >
    <g data-name="Group 21294">
      <path
        d="M16.15 1.15v1h1a3 3 0 013 3v2a1 1 0 01-2 0v-2a1 1 0 00-1-1h-1v1a1 1 0 01-2 0v-1h-8v1a1 1 0 01-2 0v-1h-1a1 1 0 00-1 1v3h5a1 1 0 010 2h-5v7a1 1 0 001 1h4a1 1 0 010 2h-4a3 3 0 01-3-3v-12a3 3 0 013-3h1v-1a1 1 0 012 0v1h8v-1c0-.552 2-.552 2 0z"
        fill="#ffd11c"
        stroke="#585858"
        strokeWidth={0.3}
      />
      <g data-name="icon-/-24x24-/-ic24-refresh">
        <path
          data-name="Icon"
          d="M13.972 11.651l1.055-1.083a.519.519 0 01.746 0 .551.551 0 01.044.714l-.044.051-.167.172q.16-.012.322-.012l.232.006a4.231 4.231 0 013.99 4.323 4.276 4.276 0 01-4.222 4.328 4.276 4.276 0 01-4.222-4.329.528.528 0 111.055 0 3.167 3.167 0 103.167-3.247q-.148 0-.294.014l.139.145a.551.551 0 010 .765.518.518 0 01-.7.045l-.05-.045-1.051-1.082a.551.551 0 01-.044-.714l.044-.051 1.055-1.083z"
          fill="#ffd11c"
          stroke="#585858"
          strokeWidth={0.2}
        />
      </g>
    </g>
  </svg>
);
